import type { HDStethEcgSnapshot, HDStethEcgSource } from './ecg-types'

export interface HDStethEcgStore extends HDStethEcgSource {
  set: (snapshot: HDStethEcgSnapshot | undefined) => void
}

/** Minimal external store; notifies only when the snapshot identity changes. */
export function createEcgStore(): HDStethEcgStore {
  let snapshot: HDStethEcgSnapshot | undefined
  const listeners = new Set<() => void>()
  return {
    getSnapshot: () => snapshot,
    subscribe: (listener) => {
      listeners.add(listener)
      return () => { listeners.delete(listener) }
    },
    set: (next) => {
      if (next === snapshot) return
      snapshot = next
      listeners.forEach((listener) => listener())
    },
  }
}
